import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, removeToken } from './myAuth'
import host from './ipconfig.js'
const service = axios.create({
  baseURL: host.ip,
  timeout: 500000 // request timeout
})
service.interceptors.request.use(
  config => {
    const token = getToken()
    if (config.method.toUpperCase() === 'POST') {
      config.headers['Content-Type'] = 'application/json'
    }
    if (token) {
      config.headers['token'] = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 0) {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 3 * 1000
      })
      if (res.code === 401) {
        removeToken()
        setTimeout(() => {
          location.reload()
        }, 1000)
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
export default service
